/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import GlobalStyleSheet from "./GlobalStyleSheet";

const animationsStyleSheet = `
  @keyframes nx-components_Spinner-rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(270deg);
    }
  }

  @keyframes nx-components_Spinner-edge-rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes nx-components_Spinner-dash {
    0% {
      stroke-dashoffset: 187;
    }

    50% {
      stroke-dashoffset: 46.75;
      transform: rotate(135deg);
    }

    100% {
      stroke-dashoffset: 187;
      transform: rotate(450deg);
    }
  }
`;

const STROKE_WIDTH_RATIO = 3 * 66;

let isEdge = null;
const determineIsEdge = () => {
  isEdge =
    /Windows/i.test(navigator.userAgent) &&
    /Edge|Trident/i.test(navigator.userAgent);
  return isEdge;
};

type Props = {
  diameter: number,
  color?: ?string,
  strokeWidth?: ?number,
  colors: ColorSet,
};

class Spinner extends React.Component<Props> {
  static defaultProps = {
    diameter: 128,
  };

  constructor(props: Props) {
    super(props);

    if (isEdge === null) {
      determineIsEdge();
    }
  }

  render() {
    const {
      colors,
      diameter,
      color = colors.PRIMARY,
      strokeWidth,
    } = this.props;
    let computedStrokeWidth;
    if (strokeWidth != null) {
      computedStrokeWidth = strokeWidth;
    } else {
      computedStrokeWidth = STROKE_WIDTH_RATIO / diameter;
    }

    return (
      <div
        data-component-name="Spinner"
        style={{
          display: "inline-block",
          width: diameter,
          height: diameter,
        }}
      >
        <GlobalStyleSheet
          id="nx-components_Spinner"
          sheet={animationsStyleSheet}
        />
        <svg
          id="svg"
          width="100%"
          height="100%"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
          style={
            isEdge
              ? {
                  animation:
                    "nx-components_Spinner-edge-rotate 1.4s linear infinite",
                }
              : {
                  animation:
                    "nx-components_Spinner-rotate 1.4s linear infinite",
                }
          }
        >
          <circle
            id="circle"
            fill="none"
            strokeWidth={computedStrokeWidth}
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="28"
            style={{
              stroke: color,
              strokeDashoffset: "0",
              ...(isEdge
                ? {
                    strokeDasharray: "90",
                  }
                : {
                    strokeDasharray: "187",
                    transformOrigin: "center",
                    animation:
                      "nx-components_Spinner-dash 1.4s ease-in-out infinite",
                  }),
            }}
          />
        </svg>
      </div>
    );
  }
}

export default withColorsProvider(Spinner);



// WEBPACK FOOTER //
// ../nx-components/src/Spinner.jsx